"use strict";
// Original KeyboardEventInit lacks some properties https://github.com/Microsoft/TypeScript/issues/15228
Object.defineProperty(exports, "__esModule", { value: true });
var KeyboardEventPolyfill = function (eventType, params) {
    if (params === void 0) { params = {}; }
    // Not possible to instantiate KeyboardEvent as it doesn't allow to set a custom key code
    var keyEvent = document.createEvent('CustomEvent');
    // prettier-ignore
    keyEvent.initCustomEvent(eventType, params.bubbles || true, params.cancelable || true, 0);
    for (var key in params) {
        keyEvent[key] = params[key];
    }
    return keyEvent;
};
exports.default = KeyboardEventPolyfill;
//# sourceMappingURL=keyboard-event.js.map